import React, { useState, useEffect } from "react";
import axios from "axios";

const Category = () => {
  const [display, setDisplay] = useState([]);
  const [display1, setDisplay1] = useState("");
  const [display2, setDisplay2] = useState("");
  const [display3, setDisplay3] = useState("");
  const [display4, setDisplay4] = useState("");

  useEffect(() => {
    getAllDisplays();
  }, []);

  const getAllDisplays = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}categoryDisplay`
      );
      // console.log(response);
      setDisplay(response.data.categoryDisplays);
      setDisplay1(response.data.categoryDisplays[0].url);
      setDisplay2(response.data.categoryDisplays[1].url);
      setDisplay3(response.data.categoryDisplays[2].url);
      setDisplay4(response.data.categoryDisplays[3].url);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section id="services" className="pt-10  pb-2 md:pt-2 ">
      <div className="mx-auto  ">
        <div
          className="w-full text-slate-800 md:mx-10 px-6 md:hidden"
          data-aos="fade-right"
          data-aos-duration="800"
        >
          <h3 className="font-poppins text-3xl md:text-5xl font-medium  border-l-4 border-secondary pl-4">
            Kategori <span className="text-secondary"> Kami</span>
          </h3>
          <p className="font-poppins font-light text-slate-500 text-sm mt-4">
            Berikut Ini adalah Kategori Merchendise Promosi yang kami miliki
          </p>
        </div>
        <div className="px-1  md:gap-4  md:px-0  md:flex md:w-full md:mt-0 md:h-calc-vh md:mx-2">
          <div
            className="w-full md:w-1/2 category relative max-w-[390px] category md:max-w-full  md:h-[675px] bg-slate-800 mt-6 md:mt-0"
            data-aos="fade-right "
            data-aos-duration="800"
          >
            <div className="product-overlay"></div>
            <img src={display1} alt="Shirt" className="w-full h-full" />
            <div className="product-details fadeIn-bottom"></div>
          </div>
          <div className="w-full   md:w-1/2 md:flex md:flex-col md:h-[675px] overflow-hidden -mt-1 md:mt-0 md:gap-4  md:mr-4 ">
            <div
              className="w-full mb-2  md:mb-0 h-[195px]  md:h-[50%] category relative   bg-slate-700 mt-3 md:mt-0 cursor-pointer  "
              data-aos="fade-left"
              data-aos-duration="800"
            >
              <div className="product-overlay"></div>
              <img src={display2} alt="Shirt" className="w-full h-full " />
            </div>
            <div className="w-full md:h-[50%] md:flex md:gap-4 md:mr-2 ">
              <div
                className="w-full md:max-w-1/2  h-[390px] md:h-auto category relative"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div className="product-overlay"></div>
                {/* <a href="#"> */}
                <img src={display3} alt="Shirt" className="w-full h-full " />
                {/* </a> */}
                <div className="product-details fadeIn-bottom">
                  {/* <a href=""> */}
                  {/* <i className="fa fa-search-plus fa-lg" aria-hidden="true"></i> */}
                  {/* </a> */}
                </div>
              </div>
              <div
                className="w-full md:max-w-1/2 bg-slate-300 h-[390px] md:h-auto mt-2 md:mt-0 category relative"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div className="product-overlay"></div>
                {/* <a href="#"> */}
                <img src={display4} alt="Shirt" className="w-full h-full " />
                {/* </a> */}
                <div className="product-details fadeIn-bottom">
                  {/* <a href=""> */}
                  {/* <i className="fa fa-search-plus fa-lg" aria-hidden="true"></i> */}
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Category;
